import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';


@Injectable({ providedIn: 'root' })
export class AuthGuardGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        const currentPath = route.children && route.children.length ? route.children[0].routeConfig.path : route.routeConfig.path;
        // const currentPath
        if (currentUser || currentPath == 'video/:id') {
            // logged in so return true
            // Or Public access for video page so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}